var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _radialGradient, _radialGradient2, _filter, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.937,
    height: 192.846,
    id: "svg28243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs28245"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient79396"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop79398"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop79406",
    offset: 0.25,
    style: {
      stopColor: "#fdfdbf",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop79404",
    offset: 0.629,
    style: {
      stopColor: "#fcfc80",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#581c00",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop79400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient79348"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f074",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop79350"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#985c00",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop79352"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient79396",
    id: "linearGradient79432",
    gradientUnits: "userSpaceOnUse",
    x1: -345.058,
    y1: -88.586,
    x2: -315.25,
    y2: 129.643
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient79396",
    id: "linearGradient79434",
    gradientUnits: "userSpaceOnUse",
    x1: -345.058,
    y1: -88.586,
    x2: -315.25,
    y2: 129.643
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient79396",
    id: "linearGradient79436",
    gradientUnits: "userSpaceOnUse",
    x1: -345.058,
    y1: -88.586,
    x2: -315.25,
    y2: 129.643
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient79396",
    id: "linearGradient79438",
    gradientUnits: "userSpaceOnUse",
    x1: -345.058,
    y1: -88.586,
    x2: -315.25,
    y2: 129.643
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient79396",
    id: "linearGradient79440",
    gradientUnits: "userSpaceOnUse",
    x1: -345.058,
    y1: -88.586,
    x2: -315.25,
    y2: 129.643
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient79396",
    id: "linearGradient79442",
    gradientUnits: "userSpaceOnUse",
    x1: -345.058,
    y1: -88.586,
    x2: -315.25,
    y2: 129.643
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient79396",
    id: "linearGradient91002",
    gradientUnits: "userSpaceOnUse",
    x1: -345.058,
    y1: -88.586,
    x2: -315.25,
    y2: 129.643
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#linearGradient79396",
    id: "radialGradient79449",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.37296 2.53708 -1.48202 .21788 569.163 1512.23)",
    cx: -474.368,
    cy: 56.235,
    fx: -474.368,
    fy: 56.235,
    r: 96.605
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#linearGradient79348",
    id: "radialGradient79468",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.53827 1.60053 -1.8274 -.61458 161.929 980.078)",
    cx: -374.378,
    cy: 25.239,
    fx: -374.378,
    fy: 25.239,
    r: 96.598
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter79384",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.195,
    id: "feGaussianBlur79386"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style3662"
  }, "\r\n            .str0{stroke:#4d4948;stroke-width:.147924}.str1,.str2,.str3{stroke:#582e3a;stroke-width:.29589}.str1,.str3{stroke-linecap:round}.str1{stroke:#e77817;stroke-width:.591821}.fil2{fill:none}.fil1{fill:#4d4948}.fil5{fill:#582e3a}.fil3{fill:#dededd}.fil0,.fil4{fill:#582e3a;fill-rule:nonzero}.fil0{fill:#000}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "layer10",
    style: {
      display: "inline"
    },
    transform: "translate(-246.972 -271.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g79470",
    transform: "rotate(9.552 594.215 400.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect79231",
    d: "M260.225 493.814 237.218 356.87a24.09 24.09 0 0 1 19.85-27.823L374.25 309.54c13.216-2.2 25.644 6.665 27.863 19.879l23.007 136.944a24.09 24.09 0 0 1-19.85 27.823l-117.181 19.509c-13.217 2.2-25.644-6.666-27.864-19.88z",
    style: {
      fill: "url(#radialGradient79468)",
      fillOpacity: 1,
      stroke: "#f8f070",
      strokeWidth: 4.61221504,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.12757203,
      filter: "url(#filter79384)"
    },
    transform: "matrix(.95305 0 0 .95305 832.459 395.005)",
    id: "g79374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path79356",
    d: "m-596.927 99.627-23.006-136.944a24.09 24.09 0 0 1 19.85-27.823l117.18-19.509c13.217-2.2 25.645 6.666 27.865 19.88l23.006 136.944a24.09 24.09 0 0 1-19.85 27.823l-117.18 19.508c-13.218 2.2-25.645-6.665-27.865-19.879z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4.61221504,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    },
    id: "g79358",
    transform: "translate(-199.085 -14.549)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.61221504,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-384.469-53.969a2.306 2.306 0 0 0-2.125 2.688l9.313 58.562a2.306 2.306 0 0 0 2.656 1.907L-249.5-11.907a2.314 2.314 0 1 0-.781-4.563L-373.094 4.25-382.03-52a2.306 2.306 0 0 0-2.438-1.969zm145.625 104.281a2.306 2.306 0 0 0-.375.063l-164.406 28.188a2.314 2.314 0 1 0 .781 4.562l164.406-28.219a2.306 2.306 0 0 0-.406-4.593z",
    id: "path79360"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-343.219-60.844a2.301 2.301 0 0 0-2.062 2.719L-335.406.25a2.314 2.314 0 1 0 4.562-.781l-9.906-58.375a2.301 2.301 0 0 0-2.469-1.938z",
    id: "path79362"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-303.125-67.781a2.301 2.301 0 0 0-2.281 2.75l10.156 58.5a2.314 2.314 0 1 0 4.563-.782l-10.188-58.53a2.301 2.301 0 0 0-2.25-1.938z",
    id: "path79364"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-364.25 71.813a2.301 2.301 0 0 0-2.313 2.718l8.907 56.094a2.31 2.31 0 1 0 4.562-.719l-8.937-56.094a2.301 2.301 0 0 0-2.219-2z",
    id: "path79366"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-321.969 64.531a2.301 2.301 0 0 0-2.062 2.719l9.844 58.063a2.301 2.301 0 1 0 4.53-.75l-9.843-58.094a2.301 2.301 0 0 0-2.469-1.938z",
    id: "path79368"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-281.563 57.594a2.301 2.301 0 0 0-2.062 2.718L-273.75 117a2.301 2.301 0 1 0 4.531-.781l-9.844-56.688a2.301 2.301 0 0 0-2.5-1.937z",
    id: "path79370"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(658.066 379.639)",
    style: {
      fill: "url(#linearGradient91002)"
    },
    id: "g79332"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "url(#linearGradient79432)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.61221504,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-384.469-53.969a2.306 2.306 0 0 0-2.125 2.688l9.313 58.562a2.306 2.306 0 0 0 2.656 1.907L-249.5-11.907a2.314 2.314 0 1 0-.781-4.563L-373.094 4.25-382.03-52a2.306 2.306 0 0 0-2.438-1.969zm145.625 104.281a2.306 2.306 0 0 0-.375.063l-164.406 28.188a2.314 2.314 0 1 0 .781 4.562l164.406-28.219a2.306 2.306 0 0 0-.406-4.593z",
    id: "path79217"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "url(#linearGradient79434)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-343.219-60.844a2.301 2.301 0 0 0-2.062 2.719L-335.406.25a2.314 2.314 0 1 0 4.562-.781l-9.906-58.375a2.301 2.301 0 0 0-2.469-1.938z",
    id: "path79219"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "url(#linearGradient79436)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-303.125-67.781a2.301 2.301 0 0 0-2.281 2.75l10.156 58.5a2.314 2.314 0 1 0 4.563-.782l-10.188-58.53a2.301 2.301 0 0 0-2.25-1.938z",
    id: "path79221"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "url(#linearGradient79438)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-364.25 71.813a2.301 2.301 0 0 0-2.313 2.718l8.907 56.094a2.31 2.31 0 1 0 4.562-.719l-8.937-56.094a2.301 2.301 0 0 0-2.219-2z",
    id: "path79223"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "url(#linearGradient79440)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-321.969 64.531c-1.276.111-2.3 1.46-2.062 2.719l9.251 54.771c.125 1.249 1.428 2.247 2.666 2.042 1.237-.205 2.15-1.57 1.865-2.792L-319.5 66.47c-.178-1.138-1.322-2.035-2.469-1.938z",
    id: "path79225"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "url(#linearGradient79442)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.60200024,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    },
    d: "M-281.563 57.594a2.301 2.301 0 0 0-2.062 2.718L-273.75 117a2.301 2.301 0 1 0 4.531-.781l-9.844-56.688a2.301 2.301 0 0 0-2.5-1.937z",
    id: "path79227"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path79388",
    d: "M379.216 307.7a26.518 26.518 0 0 0-5.344.343l-117.187 19.531c-14.438 2.404-24.175 16.035-21.75 30.469l23.031 136.938c2.425 14.434 16.062 24.184 30.5 21.78l117.188-19.5c14.437-2.403 24.175-16.065 21.75-30.5l-23.032-136.937c-2.121-12.63-12.837-21.673-25.156-22.125zm-.156 4.593a21.832 21.832 0 0 1 20.781 18.281l23 136.969c2.015 11.993-5.942 23.16-17.937 25.156l-117.188 19.5c-11.996 1.997-23.204-5.976-25.219-17.968l-23-136.97c-2.014-11.992 5.942-23.158 17.938-25.156l117.187-19.5c1.5-.25 2.98-.363 4.438-.312z",
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000",
      fill: "url(#radialGradient79449)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.61221504,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardChip);
export default __webpack_public_path__ + "static/media/credit-card-chip.5ad5f8b1cb92e263d506f0174bf340d0.svg";
export { ForwardRef as ReactComponent };